import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import PlanInfo from './PlanInfo';

import { Card } from '@pattern-library/card';

const propTypes = {
    apiUrl: PropTypes.string.isRequired
};

function PlanInfoContainer(props) {
    const [planInfoData, setPlanInfoData] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { apiUrl } = props;

    useEffect(() => {
        axios.get(apiUrl).then(response => {
            let {
                planSponsor,
                planSponsorPhone,
                agentFirstName,
                agentLastName,
                agentCompany,
                agentPhone,
                displayFin
            } = response.data;

            setPlanInfoData({
                planSponsor,
                planSponsorPhone,
                agentFirstName,
                agentLastName,
                agentCompany,
                agentPhone,
                displayFin
            });

            setDataLoaded(true);
        });
    }, [apiUrl]);

    return (
        <Card className="asc-card--sectioned" backgroundColor={'white'}>
            <ul className="asc-card-list-group">
                <li className="asc-card-list-group-item">
                    <div className="asc-card-content">
                        <h2 className="asc-card-title">Plan Contacts</h2>
                    </div>
                </li>
                {!dataLoaded ? (
                    <li className="asc-card-list-group-item">
                        <div className="asc-skeleton-holder">
                            <p
                                className="asc-skeleton"
                                style={{ width: '116px', height: '16px', display: 'block' }}
                            />
                            <div
                                className="asc-h1 asc-skeleton"
                                style={{
                                    width: '242px',
                                    height: '22px',
                                    display: 'block',
                                    marginTop: '15px'
                                }}
                            >
                                <span className="asc-acc-hidden">Loading...</span>
                            </div>
                            <p
                                className="asc-skeleton"
                                style={{
                                    width: '200px',
                                    height: '22px',
                                    display: 'block',
                                    margin: '15px 0'
                                }}
                            />
                        </div>
                    </li>
                ) : (
                    <PlanInfo data={planInfoData} />
                )}
            </ul>
        </Card>
    );
}

PlanInfoContainer.propTypes = propTypes;
export default PlanInfoContainer;
